import { Checkbox } from "@mui/material";
import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomizedTable from "../UI/CustomizedTable";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import {
  addModule,
  addPermission,
  getModule,
  updatePermission,
} from "../../utils/ApiCalls/Permission";
import PermissionTree from "../../Pages/Profile/MyProfile/PermissionComponent";
import { initialData } from "../../Pages/Profile/MyProfile/PermissionMenu";

const EditRoleInput = ({ roles }) => {
  const navigate = useNavigate();
  const [permissionData, setPermissionData] = useState(initialData);
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [module_name, setModule_Name] = useState("");

  const [roleData, setRoleData] = useState(
    roles || {
      name: "",
      read_per: [],
      create_per: [],
      update_per: [],
      delete_per: [],
      download_per: [],
    }
  );
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (roles?.name) {
      setRoleData(roles);
      setPermissionData(addPer(initialData, roles?.permission_json));
    }
    console.log(roles, "Roles Data ??");
  }, [roles?.name]);

  const addPer = (initial, permissionData) => {
    return initial.map((item) => {
      let permission =
        permissionData?.find((val) => val.key == item.key)?.permissions ||
        item.permissions;

      let children = item.childern;
      if (item?.children?.length > 0) {
        const matched = permissionData?.find((val) => val.key === item.key);
        children = addPer(item.children, matched?.children || []);
      }


      return {
        ...item,
        permissions: permission,
        children,
      };
    });
  };

  const getData = async () => {
    const data = await getModule();
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data) {
      setRows(data);
      setCount(10);
    }
  };

  const addRoleData = async (e) => {
    e.preventDefault();
    let data;
    if (roleData?.id)
      data = await updatePermission(roleData?.id, {
        ...roleData,
        permission_json: permissionData,
      });
    else
      data = await addPermission({
        ...roleData,
        permission_json: permissionData,
      });
    navigate("/profile/role");
  };

  console.log(roleData, 'RD')

  return (
    <section className="content" style={{ marginTop: "20px" }}>
      <div className="container-fluid">
        <div className="card">
          <div className="card-header two_item">
            <h5 className="card-title">Add Roles</h5>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              {" "}
            </div>
          </div>

          <div className="card-body col-lg-12">
            <PermissionTree
              treeData={permissionData}
              setTreeData={setPermissionData}
            />

            {/* <CustomizedTable
              setRows={setRows}
              setPageSize={setPageSize}
              setPage={setPage}
              pageSize={pageSize}
              page={page}
              count={count}
              columns={columns}
              rows={rows}
              title={"Permission"}
            /> */}
          </div>
          <form className="input_form" onSubmit={addRoleData}>
            <div className="card-body">
              <div className="row" style={{ alignItems: "center" }}>
                <div className="col-lg-4 ">
                  <div className="fieldrow">
                    <label className="f_label">Role Name</label>
                    <input
                      className="f_input"
                      required
                      type="text"
                      value={roleData?.name}
                      onChange={(e) =>
                        setRoleData((item) => ({
                          ...item,
                          name: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>{" "}
              </div>
              <div className=" text-right">
                <button className="btn main_submit">
                  {" "}
                  {roles?.id ? "Update" : "Add"} Role
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EditRoleInput;
